<template>
    <div>
        <div class="container-fluid mt-45">
            <Breadcrumbs />
        </div>

        <div class="container mt-4">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-8">
                    <div class="card border-0 shadow">
                        <div class="card-body py-5 px-55">
                            <h2>How will the patient receive the Test Kit?</h2>
                            
                            <div class="mt-45">
                                <button @click="next(0)" class="btn btn-success btn-block btn-lg lg-shadow px-0">Delivered via post</button>
                                <button @click="next(1)" class="btn btn-primary btn-block btn-lg lg-shadow mt-4 px-0">I have a kit to issue</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Breadcrumbs from '@/partials/site-structure/BreadcrumbsComponent.vue'
import IssueMethod from '../../../Common/enums/IssueMethod'
export default {
    name: 'DeliveryMethod',

    components: {
        Breadcrumbs
    },

    data() {
        return {
            IssueMethod
        }
    },

    mounted() {
        if(this.patientId == null) return this.$router.push({name: 'Dashboard'})
        this.setDeviceIdInTestStoreAction(null)
        this.setFacilityId(null)
        this.setEddDate(null)
        this.setTestDatesResponse([])
        this.setTestDueDate(null)
        this.setReason(0)
    },

    computed: {
        ...mapGetters({
            patientId: 'TestStore/GetPatientId',
        })
    },

    methods: {
        ...mapActions({
            setShippingAddressTypeInTestStoreAction: 'TestStore/SetShippingAddressType',
            setDeliveryMethodInTestStoreAction: 'TestStore/SetDeliveryMethod',
            setDeviceIdInTestStoreAction: 'TestStore/SetDeviceId',
            setFacilityId: 'TestStore/SetFacilityId',
            setEddDate: 'TestStore/SetEddDate',
            setTestDatesResponse: 'TestStore/SetTestDatesResponse',
            setTestDueDate: 'TestStore/SetDueDate',
            setReason: 'TestStore/SetReason',
        }),

        async next(type) {
            if(type == null || type == 'undefined') return

            if(type == 0) {
                await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.POST)
                await this.setShippingAddressTypeInTestStoreAction(0)
                return this.$router.push({name: 'TestDetails'})
            }
            if(type == 1) {
                await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.IN_PERSON)
                await this.setShippingAddressTypeInTestStoreAction(0)
                return this.$router.push({name: 'TestDetails'})
            }
        } 
    }
}
</script>